import gql from 'graphql-tag';

const REJECT_OTA = gql`
  mutation Mutation($firmwareVersion: String!) {
    rejectOTA(firmwareVersion: $firmwareVersion) {
      code
    }
  }
`;

export default REJECT_OTA;
